// The subscriber-facing name of the list, in one place so the branding can be
// changed without hunting through the page, the banner, the sidebar and the
// dashboard card. Title case: the surfaces that want it shouted apply
// textTransform themselves.
export const LIST_NAME = 'Carnivore 33'

// The webapp URL for the list. Kept beside LIST_NAME because the sidebar
// identifies the nav item by comparing this exact string, so a path edit that
// misses one site silently un-gates or orphans the link. Note this is the
// browser route only — the API endpoint is still `/carnivore-100`, matching the
// backend's internal name for the list.
export const LIST_PATH = '/carnivore-33'

// The pre-rename route, still redirected so existing bookmarks survive.
export const LEGACY_LIST_PATH = '/carnivore-100'

// Archive of every published list. Nested under LIST_PATH so the sidebar's
// pathname match keeps the 33 nav item lit on it.
export const HISTORY_PATH = `${LIST_PATH}/history`
